import React from 'react';
import { Button, Div } from 'react-images/lib/primitives';
import { className } from 'react-images/lib/utils';
import { Close, FullscreenEnter, FullscreenExit } from 'react-images/lib/components/svg';
import componentBaseClassNames from 'react-images/lib/components/componentBaseClassNames';
import PropTypes from 'prop-types';

/**
 * This is basically a copy of the Header component from react-images, added with the helper text for zoom in and out.
 */

const headerBaseClassName = componentBaseClassNames.Header;

const Header = props => {
  const {
    components,
    getStyles,
    getCloseLabel,
    getFullscreenLabel,
    innerProps,
    isModal,
    modalProps
  } = props;

  if (!isModal) return null;

  const { allowFullscreen, isFullscreen, onClose, toggleFullscreen } = modalProps;
  const FsIcon = isFullscreen ? FullscreenExit : FullscreenEnter;
  const { CloseButton, FullscreenButton } = components;
  const state = { isFullscreen, isModal };

  return (
    <Div
      css={getStyles(headerBaseClassName, props)}
      className={className(headerBaseClassName, state)}
      // TODO glam prefixer fails on gradients
      // https://github.com/threepointone/glam/issues/35
      style={{
        justifyContent: 'end',
        background: 'linear-gradient(rgba(0,0,0,0.33), rgba(0,0,0,0))'
      }}
      {...innerProps}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ color: '#8d8d8d' }}>Scroll to zoom</span>
        <span>
          {allowFullscreen ? (
            <FullscreenButton
              getStyles={getStyles}
              innerProps={{
                onClick: toggleFullscreen,
                title: getFullscreenLabel(state)
              }}
            >
              <FsIcon size={32} />
            </FullscreenButton>
          ) : null}
          <CloseButton
            getStyles={getStyles}
            innerProps={{
              onClick: onClose,
              title: getCloseLabel(state)
            }}
          >
            <Close size={32} />
          </CloseButton>
        </span>
      </div>
    </Div>
  );
};

// ==============================
// Header Buttons
// ==============================

export const headerButtonCSS = () => ({
  alignItems: 'center',
  background: 0,
  border: 0,
  color: 'rgba(255, 255, 255, 0.75)',
  cursor: 'pointer',
  display: 'inline-flex ',
  height: 44,
  justifyContent: 'center',
  outline: 0,
  padding: 0,
  position: 'relative',
  width: 44,

  '&:hover': {
    color: 'white'
  }
});

export const HeaderFullscreen = props => {
  const { children, getStyles, innerProps } = props;

  return (
    <Button
      css={getStyles('headerFullscreen', props)}
      className={className(['header_button', 'header_button--fullscreen'])}
      type="button"
      {...innerProps}
    >
      {children}
    </Button>
  );
};

export const headerCloseCSS = headerButtonCSS;
export const HeaderClose = props => {
  const { children, getStyles, innerProps } = props;

  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <Button
      css={getStyles('headerClose', props)}
      className={className(['header_button', 'header_button--close'])}
      type="button"
      {...innerProps}
    >
      {children}
    </Button>
  );
};

Header.propTypes = {
  components: PropTypes.object.isRequired,
  getCloseLabel: PropTypes.func.isRequired,
  getFullscreenLabel: PropTypes.func.isRequired,
  innerProps: PropTypes.object.isRequired,
  isModal: PropTypes.bool.isRequired,
  modalProps: PropTypes.object.isRequired,
  getStyles: PropTypes.func.isRequired
};

export default Header;
